import { emptyPagedCollection, InvoiceInfoDto, IPagedCollection } from '@sr/dto';
import { AsyncMeta, initialMeta } from 'shared/api/async-meta';

export type State = {
  invoicesList: IPagedCollection<InvoiceInfoDto>;
  meta: AsyncMeta;
  currentRequestId?: string;
};

export const initialState: State = {
  invoicesList: emptyPagedCollection,
  meta: initialMeta
};
